import React from "react";
import { resultColumns } from "./columnsData/columns";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  compactTableProps,
  smallerHeadCellProps,
} from "../../../../../../styles/muiProps";
import {MaterialReactTable} from "material-react-table";

const ResultTable = (props) => {
  const { isLoading } = props;
  const { control } = useFormContext();
  const { fields: resultFields } = useFieldArray({
    control,
    name: "DataGridView6",
  });
  return (
    <MaterialReactTable
      columns={resultColumns}
      data={resultFields ?? []}
      {...compactTableProps}
      {...smallerHeadCellProps}
      enableColumnActions={false}
      initialState={{ density: "compact" }}
      state={{
        isLoading: isLoading,
      }}
      muiTableBodyCellProps={({ cell }) => ({
        sx: {
          textAlign: "center",
          borderRight: "1px solid #ddd",
        },
      })}
      muiEditTextFieldProps={({ cell }) => ({
        sx: {
          "& .MuiInputBase-input": {
            padding: "8.5px 8px",
            textAlign: "center",
          },
        },
      })}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid var(--pv-table-border)",
          backgroundColor: "var(--pv-table-header-bg)",
          fontSize: "16px",
          pt: 2,
        },
      })}
    />
  );
};

export default ResultTable;
